// Burrow Social v1 — Design Tokens
// Shared formatters and constants for community-facing surfaces.
// Surface Builders A and B both import. Prevents two agents inventing two formatters.

export const COMMUNITY_CARD_NEUTRAL_BG = "#FDF8F3";

export function inheritedBackgroundColor(color: string | null): string {
  return color && color.length > 0 ? color : COMMUNITY_CARD_NEUTRAL_BG;
}

/** PRD §4.5: "Author +N" when N > 0; just the author when N === 0. */
export function formatChainInline(authorDisplay: string, extraDepth: number): string {
  if (extraDepth <= 0) return authorDisplay;
  return `${authorDisplay} +${extraDepth}`;
}

/** PRD §4.4: borrow badge is suppressed entirely when count is 0 — never render "0". */
export function shouldRenderBorrowBadge(count: number): boolean {
  return count > 0;
}

/** PRD §4.7: max 5 top-inspiration authors. */
export const TOP_INSPIRATION_MAX = 5;

/** PRD §4.8: onboarding gate requires exactly this many thoughts. */
export const ONBOARDING_REQUIRED_THOUGHTS = 3;

/**
 * Chrome Web Store listing for the companion extension. Shown as a skippable
 * onboarding step after the three required thoughts (desktop Chromium only —
 * Safari extension will get its own link when it ships). Leave empty to
 * disable the step entirely.
 */
export const CHROME_EXTENSION_STORE_URL =
  "https://chromewebstore.google.com/detail/burrow/hddbogdpamphlapinbeehfeajkjbpoai";

/** PRD §4.1: own-card results in the search bar dropdown. */
export const SEARCH_OWN_RESULTS_TARGET = 4;
